import {Injectable} from '@angular/core';

import {DipRegistrationContextService} from '../dip-registration-context.service';


@Injectable()
export class DipRegistrationContextGuardService  {

  constructor(private readonly dipRegistrationContextService: DipRegistrationContextService) {
  }

  canActivate(): boolean {
    return this.dipRegistrationContextService.isContextLoaded();
  }
}
